<div class="itb-dropdown-container">
  <itb-default-button *ngIf="buttonType === 'defaultBtn'" [text]="buttonText" [matMenuTriggerFor]="menu" [className]="className" [isDisabled]="'false'"></itb-default-button>
  <itb-progress-button *ngIf="buttonType === 'progressBtn'" [className]="className" [progressButton]="progressButton" [matMenuTriggerFor]="menu"></itb-progress-button>
  <itb-round-button [matMenuTriggerFor]="menu" *ngIf="buttonType === 'roundBtn'" [className]="progressButton.roundButtonType" [iconClassName]="progressButton.iconClassName"></itb-round-button>
  <itb-icon *ngIf="buttonType === 'iconBtn'" [className]="className" [matMenuTriggerFor]="menu"></itb-icon>
  <button [matMenuTriggerFor]="menu" *ngIf="buttonType === 'profileBtn'" class="profile-dropdown-toggle">
    <img [src]="progressButton.imagePath" />
  </button>
  <mat-menu class="itb-dropdown" #menu="matMenu" xPosition='before'>
    <ng-content></ng-content>
  </mat-menu>
</div>